// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../engines/components/BasePopUpLayer";
import O1HD, { modules } from "../../../engines/gameEngine";
import utilsModel from "../../../engines/libs/utilsModel";
import utilsView from "../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../engines/modules/uiModule";
import { FileKind } from "../../define/FileKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ModelDialogLayer extends BasePopUpLayer {


    static show(
        strMsg: string
        , cancelFun?: Function
        , confirmFun?: Function
        , strConfirm?: string
        , strCancel?: string
        , bVideo?: boolean
        , zIndex: number = UI_Z_INDEX.DIALOG
        , videoDesc?: string
    ) {
        let filePath = 'gameCommon/prefab/basic/ModelDialogLayer';
        utilsView.openPopupLayer(
            filePath
            , modules().uiControlModule.getGameBundlePath() as any
            , null
            , {
                strMsg: strMsg
                , cancelFun: cancelFun
                , confirmFun: confirmFun
                , strConfirm: strConfirm
                , strCancel: strCancel
                , bVideo: bVideo
                , videoDesc: videoDesc
            }
            , zIndex
        );
    }


    @property(cc.Label)
    labelDesc: cc.Label = null;
    @property(cc.Label)
    labelConfirm: cc.Label = null;
    @property(cc.Label)
    labelConfirmVideo: cc.Label = null;
    @property(cc.Label)
    labelCancel: cc.Label = null;

    @property(cc.Node)
    btnConfirmVideo: cc.Node = null;
    @property(cc.Node)
    btnConfirm: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        let data = this._carryData;
        this.labelDesc.string = data.strMsg;

        this.btnConfirm.active = false;
        this.btnConfirmVideo.active = false;
        if (data.bVideo) {
            this.btnConfirmVideo.active = true;
            if (data.strConfirm) {
                this.labelConfirmVideo.string = data.strConfirm;
            }
        } else {
            this.btnConfirm.active = true;
            if (data.strConfirm) {
                this.labelConfirm.string = data.strConfirm;
            }
        }

        if (data.strCancel) {
            this.labelCancel.string = data.strCancel;
        }
    } 

    onClickCancel() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        if (this._carryData.cancelFun) {
            this._carryData.cancelFun();
        }
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        if (this._carryData.confirmFun) {
            this._carryData.confirmFun();
        }
    }

    onClickConfirmAd() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.destroyNode();
            if (this._carryData.confirmFun) {
                this._carryData.confirmFun();
            }
        },()=>{
 
        }, null, this._carryData.videoDesc || '');
    }
    // update (dt) {}
}
